import { ICurrency } from '@/interfaces/ICurrency';

/**
 * Pure-data leaf module: `Globals.ts` touches `window` at module scope and
 * cannot be imported from node-environment unit tests, so anything that only
 * needs the currency list must import it from here.
 */
export const CURRENCIES: ICurrency[] = [
  { value: 'ARS', text: 'Peso argentino', symbol: '$' },
  { value: 'BRL', text: 'Real brasileiro', symbol: 'R$' },
  { value: 'UYU', text: 'Peso uruguayo', symbol: '$' },
  { value: 'CLP', text: 'Peso chileno', symbol: '$' },
  { value: 'DOP', text: 'Peso dominicano', symbol: '$' },
  { value: 'EUR', text: 'Euro', symbol: '€' },
  { value: 'MXN', text: 'Peso mexicano', symbol: '$' },
  { value: 'COP', text: 'Peso colombiano', symbol: '$' },
  { value: 'CRC', text: 'Colón costarricense', symbol: '₡' },
  { value: 'PEN', text: 'Nuevo Sol', symbol: 'S/' },
  { value: 'USD', text: 'Dolar estadounidense', symbol: '$' },
  { value: 'PYG', text: 'Guarani paraguayo', symbol: '₲' },
  { value: 'VES', text: 'Bolívar venezolano', symbol: 'Bs.' },
  { value: 'BOB', text: 'Boliviano', symbol: 'Bs.' },
];
